import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Modal, Grid } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { updateQueryString } from '../../../../services/router/actions';
// @ts-ignore
import { dispatchClickEvent } from '../../../../services/googleTagManager/actions';
// @ts-ignore
import ErrorBoundaryAlert from '../../../../components/ErrorBoundaryAlert';
// @ts-ignore
import { ErrorBoundary } from '../../../../workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

interface ConnectedProps {
    feedbackModal?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
    dispatchClickEvent: Function;
}

type Props = ConnectedProps & DispatchProps;

export class FeedbackModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            feedbackModal: undefined
        });
    };

    handleClick = (): void => {
        this.props.dispatchClickEvent('Send feedback email');
    };

    render(): React.ReactElement {
        const { feedbackModal } = this.props;

        return (
            <Modal
                open={!!feedbackModal}
                centered={false}
                onClose={this.handleClose}
                size="tiny"
                closeIcon
            >
                <ErrorBoundary
                    namespace="FeedbackModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>
                        Your Feedback is important to us
                    </Modal.Header>
                    <Modal.Content>
                        <p>
                            Have an idea on how Orchard Hand could be improved?
                        </p>
                        <p>
                            Send us your feedback to{' '}
                            <a
                                onClick={this.handleClick}
                                href="mailto:orchardhand@tandg.global?subject=Orchard Hand Feedback"
                            >
                                orchardhand@tandg.global
                            </a>
                        </p>
                        <Grid>
                            <Grid.Column mobile={16} tablet={4} computer={4}>
                                <Button
                                    basic
                                    primary
                                    onClick={this.handleClose}
                                    fluid
                                >
                                    Close
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    feedbackModal: makeSelectQueryStringValue('feedbackModal')
});

export default connect(mapStateToProps, {
    updateQueryString,
    dispatchClickEvent
})(FeedbackModalComponent);
